<script setup>
defineProps({
    jobad: {
        type: Object,
        required: true,
    },
    fadeOutDown: {
        type: Boolean,
        default: false,
    },
});
</script>

<template>
    <div
        :class="{ 'fade-out-down': fadeOutDown }"
        v-html="jobad.html"
        :data-tid="jobad.tid"
    />
</template>

<style>
.fade-out-down {
    mask-image: linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%);
}
</style>
